<article class="feed-card-container">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-linear-to-br from-primary to-brand-agency-dark text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M8 12h8" />
                        <path d="M12 8v8" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <h3 class="truncate text-base font-semibold text-primary">
                    Brief Created!</h3>
                <p class="min-w-0 text-sm text-secondary">
                    Brief was created successfully
                    @if (activity.brief.campaign && activity.brief.campaign.campaignName !== 'Default Group') {
                    <span class="text-sm text-secondary">in campaign </span>
                    <span class="italic text-sm text-secondary">
                        {{ activity.brief.campaign.campaignName }}
                    </span>
                    }
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-start justify-start h-full">

            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>
    </div>

    <div class="grid w-full min-w-0 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <!-- Channel -->
        @if (createdAsk().source === 'pieces') {
            <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div class="min-w-0 flex-1">
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">{{ createdAsk().label }}</p>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">{{ createdAsk().detail }}</p>
            </div>
        </div>
        } @else if (activity.brief.shoutBrief) {
            <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div class="shrink-0 p-2 rounded-lg bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <img [src]="getChannelIcon(activity.brief.shoutBrief.socialPlatform)" alt=""
                    class="size-8" />
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">Channel</p>
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">{{ getChannelName(activity.brief.shoutBrief.socialPlatform) }}
                    @if (activity.brief.shoutBrief.crossPlatforms && activity.brief.shoutBrief.crossPlatforms.length > 0) {
                    <span class="text-sm text-secondary">+{{ activity.brief.shoutBrief.crossPlatforms.length }} additional channels</span>
                    }
                </p>

            </div>
        </div>
        } @else {
        <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div class="shrink-0 p-2 rounded-lg bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10">
                <img src="../../../../../assets/social-icon/ugc-videos.svg" alt=""
                    class="size-8" />
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">Content type</p>
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">UGC Only <span class="font-normal text-gray-500 dark:text-gray-400">· not posted on socials</span></p>
            </div>
        </div>
        }
        <!-- Channel END -->

        <!-- Product -->
        <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div class="shrink-0 rounded-lg bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10 p-2">
                <img [src]="imageService.getImageSource(activity.brief.product.productImage, 'gallery')" alt=""
                    class="size-8" />
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">Product</p>
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">{{ activity.brief.product.productName }}</p>
            </div>
        </div>
        <!-- Product END -->

        <!-- Created By -->
        <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div class="shrink-0">
                <img [src]="imageService.getImageSource(activity.createdByUser.photoURL, 'gallery')" alt=""
                    class="size-10 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10" />
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">Created By</p>
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">{{ activity.createdByUser.firstName }} {{
                    activity.createdByUser.lastName }}</p>
            </div>
        </div>
        <!-- Created By END -->

        <!-- Created Date -->
        <div
            class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div
                class="shrink-0 size-10 rounded-lg bg-gray-300 outline -outline-offset-1 outline-black/5 dark:bg-gray-700 dark:outline-white/10 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6 text-secondary">
                    <path d="M16 19h6" />
                    <path d="M16 2v4" />
                    <path d="M19 16v6" />
                    <path d="M21 12.598V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5" />
                    <path d="M3 10h18" />
                    <path d="M8 2v4" />
                </svg>
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="truncate text-sm text-gray-500 dark:text-gray-400">Created Date</p>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ activity.date | date:'dd MMM yyyy' }}</p>
            </div>
        </div>
        <!-- Created Date END -->

        <!-- Created Date -->
        <div
            class="col-span-1 sm:col-span-2 relative flex min-w-0 items-center space-x-3 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-xs focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary hover:border-gray-400 dark:border-white/10 dark:bg-gray-800/50 dark:shadow-none dark:focus-within:outline-primary dark:hover:border-white/25">
            <div
                class="shrink-0 size-10 rounded-lg bg-gray-300 outline -outline-offset-1 outline-black/5 dark:bg-gray-700 dark:outline-white/10 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-6 text-secondary">
                    <line x1="4" x2="20" y1="9" y2="9" />
                    <line x1="4" x2="20" y1="15" y2="15" />
                    <line x1="10" x2="8" y1="3" y2="21" />
                    <line x1="16" x2="14" y1="3" y2="21" />
                </svg>
            </div>

            <div class="min-w-0 flex-1">
                <span aria-hidden="true" class="absolute inset-0"></span>
                <p class="text-sm text-secondary">Brief Goal</p>
                <p class="truncate text-sm font-medium text-primary">The goals of the brief...</p>
            </div>
        </div>
        <!-- Created Date END -->
    </div>

</article>